import { Component, Input } from '@angular/core';

@Component({
  selector: 'idp-error-info-text',
  templateUrl: './error-info-text.component.html',
  styleUrls: ['./error-info-text.component.scss']
})
export class ErrorInfoTextComponent {
  @Input() errormsg = '';
  @Input() errorinfo = '';
}
